import moment from 'moment'

const MAX_ACCEPTANCE_SCORE = 70
const MAX_SCORE_HOUR = 300

const getDatesFromDateRange = (from, to) => {
  const startFrom = moment(parseInt(from, 10))
  const endAt = moment(parseInt(to, 10))
  const dates = []

  while (startFrom.isSameOrBefore(endAt, 'day')) {
    dates.push(startFrom.format('YYYY-MM-DD'))
    startFrom.add(1, 'days')
  }

  return dates
}

const getOrderAnalyticsByDate = ({ orders, date }) => {
  const orderDate = moment(date, 'YYYY-MM-DD')

  const ordersByDate = orders.filter(order => moment(parseInt(order.created_at, 10)).isSame(orderDate, 'day'))
  const orderCount = ordersByDate.length

  let deliveredOrderCount = 0
  let rejectedOrderCount = 0
  let maximumCountedOrder = 0
  let earnPerDay = 0

  for (let index = 0; index < orderCount; index += 1) {
    const order = ordersByDate[index];

    if (order.status === 'delivered') {
      deliveredOrderCount += 1
      maximumCountedOrder += 1

      const feeRate = order.fee_rate || 25
      const fullDeliveryFee = order.delivery_fee
      const earnFee = Number(fullDeliveryFee * (1 - (feeRate / 100)))

      earnPerDay += earnFee
    } else if (order.status === 'rejected') {
      rejectedOrderCount += 1

      const foundDistance = Number(order.distance || 0) // distance between driver and merchant
      const findingRadius = Number(order.finding_radius || 0)

      const isCannotNotified = order.rejected_reason === 'cannot-notify'
      const isSwitchedDriver = order.rejected_reason === 'switch-driver'

      const isInRadius = foundDistance < findingRadius

      if (isInRadius && (!isCannotNotified || !isSwitchedDriver))
        maximumCountedOrder += 1
    }
  }
  const acceptance = maximumCountedOrder > 0 ? parseInt(MAX_ACCEPTANCE_SCORE * deliveredOrderCount / maximumCountedOrder, 10) : 0

  return ({
    acceptance,
    orderCount,
    deliveredOrderCount,
    rejectedOrderCount,
    earnPerDay: Number(parseFloat(earnPerDay).toFixed(2)),
  })
}

const getPerformances = ({ dates, orders, activities }) => {
  const workingDurations = {}

  dates.forEach(d => {
    const date = moment(d, 'YYYY-MM-DD')
    let duration = 0

    if (activities.length > 0) {
      const activitiesEachDay = activities.filter(activity =>
        moment(parseInt(activity.created_at, 10)).isSame(date, 'day') &&
        activity.online &&
        activity.offline &&
        activity.completed_pair
      )

      activitiesEachDay.forEach(activity => {
        const startAt = moment(parseInt(activity.online.timestamp, 10))
        const endAt = moment(parseInt(activity.offline.timestamp, 10))

        const durationInSingleActivity = moment.duration(endAt.diff(startAt, 'milliseconds')).as('milliseconds')
        duration += durationInSingleActivity
      })
    }

    const orderAnalytics = getOrderAnalyticsByDate({ orders, date })

    let durationInMinute = parseInt(moment.duration(duration, "milliseconds").as("minutes"), 10)

    durationInMinute = durationInMinute > 300 ? 300 : durationInMinute

    const workingScore = parseInt((30 * durationInMinute) / MAX_SCORE_HOUR, 10)
    const acceptanceRate = parseInt(orderAnalytics.acceptance, 10)
    const scoring = parseInt(workingScore + acceptanceRate, 10)

    workingDurations[date] = {
      duration,
      scoring,
      ...orderAnalytics
    }
  })

  return workingDurations
}

export default {
  getDatesFromDateRange,
  getPerformances,
  getOrderAnalyticsByDate
}



// WEBPACK FOOTER //
// ./src/prototypes/driver.js